import React from "react";

import "./Legal.css";

function Terms() {
  return (
    <div className="Terms">
      <main className="Terms__container">
        <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">
          Terms and Conditions
        </h1>
        <p className="text-sm text-gray-500 text-center mb-12">
          Last updated: 26 Jan. 2025
        </p>
        <section className="space-y-8 text-gray-700">
          <div>
            <h2 className="text-xl font-semibold mb-4">1. Introduction</h2>
            <p>
              Welcome to Luxury Spain Properties, a real estate website operated
              by Pascal BRETEL. These terms and conditions govern your use of
              this website. By accessing or using the website, you agree to
              comply with these terms. If you do not agree, please discontinue
              use immediately.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-4">
              2. Intellectual Property Rights
            </h2>
            <p>
              All materials on this website, including text, graphics, logos,
              images, and any software, are the intellectual property of Luxury
              Spain Properties or licensed for use. Unauthorized reproduction,
              distribution, or modification of any content is strictly
              prohibited. Permission to use materials may be granted upon
              written request.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-4">3. Restrictions</h2>
            <ul className="list-disc ml-6 space-y-2">
              <li>You may not use this website for unlawful purposes.</li>
              <li>
                You must not attempt to gain unauthorized access to the website
                or its server.
              </li>
              <li>
                You may not use automated systems (such as bots or scrapers) to
                interact with the website without prior permission.
              </li>
            </ul>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-4">4. Third-Party Links</h2>
            <p>
              This website may contain links to third-party websites or
              services. Luxury Spain Properties has no control over and assumes
              no responsibility for the content, privacy policies, or practices
              of third-party sites. Access these links at your own discretion.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-4">
              5. Disclaimer of Liability
            </h2>
            <p>
              The website and its content are provided "as is" without
              warranties of any kind, either express or implied. Luxury Spain
              Properties does not guarantee the accuracy, reliability, or
              availability of the website. To the fullest extent permitted by
              law, we disclaim any liability for damages or losses arising from
              your use of this site.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-4">6. Privacy Policy</h2>
            <p>
              Any personal data submitted through the website will be handled
              according to our Privacy Policy. Please review the{" "}
              <a href="/privacy">Privacy Policy</a>
              for detailed information on how we manage and protect your data.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-4">7. Governing Law</h2>
            <p>
              These terms and conditions are governed by and construed in
              accordance with the laws of Spain. Any disputes arising in
              connection with these terms shall be subject to the exclusive
              jurisdiction of the courts in Spain.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-4">8. Website Hosting</h2>
            <p>
              This website is hosted by <strong>Hostinger</strong>. For
              hosting-related inquiries, please refer to their official website.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-4">
              9. Changes to These Terms
            </h2>
            <p>
              Luxury Spain Properties reserves the right to modify these terms
              and conditions at any time without prior notice. By continuing to
              use the website, you agree to be bound by the latest version of
              these terms.
            </p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-4">
              10. Contact Information
            </h2>
            <p>
              If you have any questions about these terms, please contact us via
              email at:{" "}
              <a
                href="mailto:info@luxuryspainproperties.com"
                className="text-blue-600 underline"
              >
                info@luxuryspainproperties.com
              </a>
              .
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Terms;
